"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CellButton = exports.Column = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const lodash_1 = require("lodash");
/**
 *
 * See usage example in date-picker/date-picker.js file
 *
 * WARNING: Before changing this file, please strongly consider whether your change is
 * necessary (we want to avoid unexpected bugs in other views).
 * This code is meant to be shared by many views throughout our app and should not
 * contain logic specifc to how your view is using it.
 *
 */
const disabledColumnStyle = styled_components_1.css `
  background: ${(props) => props.theme.colors.backgroundInactive};
  border-radius: 2px;
  &[data-disabled] + &[data-disabled] {
    box-shadow: -4px 0 0 ${(props) => props.theme.colors.backgroundInactive};
  }
`;
exports.Column = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  flex-basis: 100%;
  flex: 1;
  line-height: 30px;
  vertical-align: middle;
  padding: 0 ${(props) => props.theme.spacing.xxs};

  ${(props) => props['data-disabled'] && disabledColumnStyle}
`;
exports.CellButton = styled_components_1.default.button.attrs((props) => ({
    isSelected: props.isSelected || false,
})) `
  appearance: none;
  background: none;
  width: 100%;
  line-height: 30px;
  vertical-align: middle;
  border: none;
  justify-content: center;
  align-items: center;
  color: ${(props) => props.theme.colors.textDark};
  text-align: center;
  white-space: nowrap;
  user-select: none;
  cursor: pointer;

  &:hover,
  &:focus-visible {
    border-radius: 50%;
    outline: ${(props) => props.theme.outline};
  }

  ${(props) => props.isSelected &&
    `
    background: ${props.theme.colors.primaryAccent};
    border-radius: 50%;
    color: ${props.theme.colors.white};
  `}

  ${(props) => props.disabled &&
    `
    color: ${props.theme.colors.textInactive};
    cursor: default;
    &:hover {
      outline: none;
    }
  `}
`;
const CalendarCell = ({ cellDate, isSelected, isDisabled, onDateChange, handleInputChange, }) => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement(exports.Column, { "data-disabled": !!(cellDate.day && isDisabled) }, cellDate.day && (react_1.default.createElement(exports.CellButton, { disabled: isDisabled, key: cellDate.day, value: cellDate.day, isSelected: isSelected, type: "button", onClick: () => {
            onDateChange({
                day: cellDate.day,
                month: cellDate.month,
                year: cellDate.year,
            });
            handleInputChange(`${cellDate.year}-${lodash_1.padStart(String(cellDate.month), 2, '0')}-${lodash_1.padStart(String(cellDate.day), 2, '0')}`);
        } }, cellDate.day)))));
exports.default = CalendarCell;
